import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";

import defaultCardImage from "images/shield-icon.svg";
import { ReactComponent as SvgDecoratorBlob3 } from "images/svg-decorator-blob-3.svg";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomizeIconImage from "images/customize-icon.svg";
import FastIconImage from "images/fast-icon.svg";
import ReliableIconImage from "images/reliable-icon.svg";
import SimpleIconImage from "images/simple-icon.svg";

const Container = tw.div`relative border-t-2 border-b-2 w-full`
// ✅ RTL alignment applied on whole container
const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto py-20 md:py-24`}
  direction: rtl;
  text-align: right;
`;

const Subheading = styled(SubheadingBase)`
  ${tw`mb-4 text-xl lg:text-2xl xl:text-3xl`}
  font-family: "CustomFont", sans-serif;
  color: var(--primary-color);
`;

const Heading = styled(SectionHeading)`
  ${tw`w-full text-xl lg:text-2xl xl:text-3xl font-bold`}
  font-family: "CustomFont", sans-serif;
  color: var(--primary-color);
`;

const Description = styled(SectionDescription)`
  ${tw`w-full text-xl lg:text-2xl xl:text-3xl mt-4`}
  font-family: "CustomFont", sans-serif;
`;

const VerticalSpacer = tw.div`mt-10 w-full`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 px-6 flex`}
`;

const Card = styled.div`
  ${tw`flex flex-col mx-auto max-w-xs items-center px-6 py-10 border-2 border-dashed rounded-lg mt-12`};
  border-color: var(--primary-color);
  font-family: "CustomFont", serif;
  transition: all 0.3s ease-in-out;
  background: white;
  text-align: center;
  direction: rtl;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(199, 138, 65, 0.15);
    border-style: solid;
  }

  .imageContainer {
    ${tw`text-center rounded-full p-6 flex-shrink-0 relative`};
    border: 2px solid var(--primary-color);
    transition: all 0.3s ease-in-out;
    background: linear-gradient(
      135deg,
      rgba(199, 138, 65, 0.1) 0%,
      rgba(199, 138, 65, 0.05) 100%
    );

    img {
      ${tw`w-8 h-8`}
    }
  }

  &:hover .imageContainer {
    background: linear-gradient(
      135deg,
      rgba(199, 138, 65, 0.2) 0%,
      rgba(199, 138, 65, 0.1) 100%
    );
    transform: scale(1.1);
  }

  .textContainer {
    ${tw`mt-6`};
    text-align: center;
    direction: rtl;
  }

  .title {
    font-family: "CustomFont", serif;
    ${tw`mt-2 tracking-wide font-bold text-xl lg:text-2xl xl:text-3xl leading-snug`}
    color: var(--primary-color);
    text-align: center;
    direction: rtl;
  }

  .description {
    font-family: "CustomFont", serif;
    ${tw`mt-3 font-medium leading-relaxed text-base lg:text-lg xl:text-xl text-gray-700`}
    text-align: center;
    direction: rtl;
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

export default ({
  cards = null,
  heading = "Amazing Features",
  subheading = "Features",
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
}) => {
  const defaultCards = [
    {
      imageSrc: ShieldIconImage,
      title: "Secure",
      description:
        "We strictly only deal with vendors that provide top notch security.",
    },
    {
      imageSrc: SupportIconImage,
      title: "Khsoosiyath1",
      description: "Description 1",
    },
    {
      imageSrc: CustomizeIconImage,
      title: "Khsoosiyath2",
      description: "Description 2",
    },
    {
      imageSrc: ReliableIconImage,
      title: "Khsoosiyath3",
      description: "Description 3",
    },
    {
      imageSrc: FastIconImage,
      title: "Khsoosiyath4",
      description: "Description 4",
    },
    {
      imageSrc: SimpleIconImage,
      title: "Khsoosiyath5",
      description: "Description 5",
    },
    {
      imageSrc: SimpleIconImage,
      title: "Khsoosiyath6",
      description: "Description 6",
    },
  ];

  if (!cards) cards = defaultCards;

  return (
    <Container>
      <ThreeColumnContainer>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        {description && <Description>{description}</Description>}
        <VerticalSpacer />
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <img src={card.imageSrc || defaultCardImage} alt="" />
              </span>
              <span className="textContainer">
                <span className="title">{card.title || "Fully Secure"}</span>
                <p className="description">
                  {card.description ||
                    "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud."}
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};
